// Leaflet-free home for DEFAULT_OSRM_CONFIG.
//
// Importing this constant from ./constants would drag leaflet (~143 kB raw)
// into the main bundle, because constants.js does `import L from 'leaflet'`
// at the top for its other (page-internal) exports. useGoogleMaps is reached
// from main via the hooks barrel, so it must read this config from a module
// that does not transitively touch leaflet.
export const DEFAULT_OSRM_CONFIG = {
  routingUrl: 'https://your-osrm-server.com/route/v1',
  googleApiKey: 'AIzaSyAa26O1uQxV0dSOO-P4_OXdvBOZVlKZgcA',
  options: {
    profile: 'driving',
    steps: true,
    annotations: true,
    geometries: 'geojson',
    overview: 'full',
  },
};
